import React from "react"
import Slider from "react-slick"
import UserTestimonio from "../../images/Seba.png"
//import UserTestimonio2 from "../../images/Laura.png"
import Comillas from "../../images/comillas.png"

const Testimonios = () => {
  var settings = {
    arrows: false,
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 6000,
    speed: 500,
    swipeToSlide: true,
  }
  return (
    <section className="bg-primary text-white">
      <div className="mx-auto container px-8 py-20">
        <Slider {...settings}>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
            <div className="justify-self-start md:justify-self-end">
              <img src={Comillas} alt="Chantal Boad" />
            </div>
            <div className="col-span-2 self-center">
              <h3 className="text-4xl lg:text-5xl font-bold pb-3">
                Sebastian Barrenechea
              </h3>
              <h4 className="text-3xl pb-8 text-secondary">
                Manager at Technology Solutions
              </h4>
              <p>
                We have done many projects for our digital media platform with
                several development teams from Avalith and the result of each of
                them was very positive. They have excellent predisposition and
                know to conform to the different technologies we use.
              </p>
            </div>
            <div>
              <img src={UserTestimonio} alt="Sebastian Barrenechea" />
            </div>
          </div>
          {/* Testimonio 2 */}
          {/* <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
            <div className="justify-self-start md:justify-self-end">
              <img src={Comillas} alt="Matias Cabrera" />
            </div>
            <div className="col-span-2 self-center">
              <h3 className="text-4xl lg:text-5xl font-bold pb-3">
                Matias Cabrera
              </h3>
              <h4 className="text-3xl pb-8 text-secondary">Proyect Manager</h4>
              <p>
                Avalith is one of our golden partners. Their main strength is
                that they will do anything to make successful each project they
                participate. Their management is always reachable to fix any
                problem and make changes and improvements.
              </p>
            </div>
            <div>
              <img src={UserTestimonio2} alt="Matias Cabrera" />
            </div>
          </div> */}
        </Slider>
      </div>
    </section>
  )
}

export default Testimonios
